import camelcaseKeys from 'camelcase-keys'

export class ActivityGroup {
  constructor (params = {}) {
    const { id, name, groupBlockThreshold } = params ? camelcaseKeys(params) : {}
    this.id = id
    this.name = name || null
    this.groupBlockThreshold = groupBlockThreshold || null
  }
}
